<section class="hero-area-bg" id="hero-area">
    <div class="container">
        <div class="row align-items-center row-flex">
            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="test-contents">
                    <h1 class="test-title">Improve Your NEET 2021 <br>Performance With <br>Full Syllabus <span
                            class="label label-danger"> Test series</span></h1>
                    <p>Created by top faculties to improve your rank</p>
                    <div class="numbertest-field" [formGroup]='mobileNumberForm'>

                        <span class="code">+ 91</span>
                        <input type="tel" maxlength="10" class="numbertest-input" (onchange)="onInputChange()"
                            (keyup)="onInputChange()" placeholder="MOBILE NUMBER" formControlName='mobilenumber'>
                        <button type="button" (click)="signup('neet_ts_1', {number: mobileNumberForm.value.mobilenumber, dialCode: '+91'})"  [disabled]="!mobileNumberValid"
                            class="starttest-btn"><b>START LEARNING</b></button>


                    </div>
                    <div class="d-flex justify-content-center IL_sc-click font-weight-bold">
                        <span class="assessment_mt-10" *ngIf="tenant != 'srichaitanya'">Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
                    </div>
                </div>

            </div>

            <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                <div class="introtest-img">
                    <img src="assets/img/neet-landing/test-banner.png" class="testbanner" alt="">
                </div>
            </div>
        </div>
    </div>
</section>
<!-- feature area -->
<section class="feature-area">
    <div class="container">
        <div class="feature-head">
            <h1>NEET Test Series Features</h1>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="feature-box">
                    <div class="feature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f1.png" alt="">
                        </figure>
                    </div>
                    <h4>All India Ranking</h4>
                    <p>Benchmark your performance with more than 1 lac students.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="feature-box">
                    <div class="feature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f2.png" alt="">
                        </figure>
                    </div>
                    <h4>Analysis</h4>
                    <p>Get detailed analysis of each test to help you work on the improvement plan.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="feature-box">
                    <div class="feature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f3.png" alt="">
                        </figure>
                    </div>
                    <h4>Edge Over Others</h4>
                    <p>Prepared by top faculties who aim at producing top ranks, and get you an edge over other similar
                        test series.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="feature-box">
                    <div class="feature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f4.png" alt="">
                        </figure>
                    </div>
                    <h4>Multi Device</h4>
                    <p>You can take your test either on Phone, Tablet or Laptop / Desktop.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="feature-box">
                    <div class="feature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f5.png" alt="">
                        </figure>
                    </div>
                    <h4>Syllabus Coverage</h4>
                    <p>The test series is based on complete syllabus and as per new NEET pattern to help to you perform
                        better.</p>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="feature-box">
                    <div class="feature-icon">
                        <figure>
                            <img src="assets/img/neet-landing/f6.png" alt="">
                        </figure>
                    </div>
                    <h4>Added Advantage</h4>
                    <p>Clarify your doubts with Infinitylearn doubts app, get your answers for FREE.</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Test series schedule -->
<section class="schedule-area">
    <div class="container">
        <div class="feature-head">
            <h1>Test Series Schedule</h1>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 1</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 17th July, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SAT : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 2</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 18th July, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SUN : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 3</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 24th July, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SAT : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 4</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 25th July, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SUN : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 5</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 31st July, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SAT : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 6</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 1st Aug, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SUN : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 7</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 7th Aug, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SAT : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 8</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 8th Aug, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SUN : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 9</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 14th Aug, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SAT : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- number field two-->
<section class="numberfield-area-two">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12 col-xs-12 ">
                <div class="numbertest-field number-center-two" [formGroup]='mobileNumberForm'>
                    <span class="code">+ 91</span>
                    <input type="tel" maxlength="10" class="numbertest-input" (onchange)="onInputChange()"
                        (keyup)="onInputChange()" placeholder="MOBILE NUMBER" formControlName='mobilenumber'>
                    <button type="button" (click)="signup('neet_ts_2', {number: mobileNumberForm.value.mobilenumber, dialCode: '+91'})"  [disabled]="!mobileNumberValid"
                        class="starttest-btn"><b>START LEARNING</b></button>
                </div>
                <div class="d-flex justify-content-center IL_sc-click white font-weight-bold">
                    <span class="assessment_mt-10" *ngIf="tenant != 'srichaitanya'">Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Test series schedule -->
<section class="schedule-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 10</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 21st Aug, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SAT : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 11</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 22nd Aug, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SUN : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 12</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 28th Aug, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SAT : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 13</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 29th Aug, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SUN : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 14</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 31st Aug, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>TUE : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 15</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 2nd Sep, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>THU : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 16</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 4th Sep, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SAT : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 17</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 5th Sep, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>SUN : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 18</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 6th Sep, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>MON : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 19</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 8th Sep, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>WED : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-xs-12">
                <div class="schedule-box">
                    <div class="schedule-head">
                        <h4>ILTS 20</h4>
                        <div class="schedule-icon">
                            <figure>
                                <img src="assets/img/neet-landing/FREE.png" alt="">
                            </figure>
                        </div>
                    </div>
                    <div class="schedule-content">
                        <div class="con-pad">
                            <span><i class="fa fa-calendar-o" aria-hidden="true"></i>DATE : 10th Sep, 2021</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clock-o" aria-hidden="true"></i>FRI : 2 pm to 5 pm</span>
                        </div>
                        <div class="con-pad">
                            <span><i class="fa fa-clipboard" aria-hidden="true"></i>Full Syllabus</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- number field three-->
<section class="numberfield-area-three">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12 col-md-12 col-xs-12 ">
                <div class="numbertest-field number-center-three" [formGroup]='mobileNumberForm'>
                    <span class="code">+ 91</span>
                    <input type="tel" class="numbertest-input" formControlName='mobilenumber' placeholder="MOBILE NUMBER">
                    <button type="button" class="starttest-btn" data-toggle="modal" (click)="signup('neet_ts_3', {number: mobileNumberForm.value.mobilenumber, dialCode: '+91'})" ><b>START
                            LEARNING</b></button>
                </div>
                <div class="d-flex justify-content-center IL_sc-click font-weight-bold">
                    <span class="assessment_mt-10" *ngIf="tenant != 'srichaitanya'">Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Footer Section Starts -->
<!-- <section class="footer-sec">
        <div class="container-fluid">
            <div class="row">
                    <div class="col-lg-2 col-md-6 col-xs-12">
                        <div class="footer-links">
                            <ul class="quicklinks">
                                <li><a href="#" ><b>Courses</b></a></li>
                                <li><a href="#" >NEET</a></li>
                                <li><a href="#" >JEE</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-1 col-md-6 col-xs-12">
                        <div class="footer-links">
                            <ul class="quicklinks">
                                <li><a href="#" ><b>About Us</b></a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-xs-12">
                        <div>
                            <ul class="address-list">
                                <li><i class="fa fa-map-marker" aria-hidden="true"></i>
                                    <p>NCC Building, Durgamma Cheruvu Road,<br> Vittal Rao Nagar, HITECH City,<br> Hyderabad, Telangana 500081.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-xs-122">
                        <div>
                            <ul class="address-list">
                                
                                <li><i class="fa fa-envelope" aria-hidden="true"></i><a href="#" class="" >info@infinitylearn.com</a>
                                    
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-xs-12">
                        <div class="social">
                            <ul class="socialmedia">
                                <li><a href=""><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                                <li><a href=""><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                                <li><a href=""><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                                <li><a href=""><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                                <li><a href=""><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                            </ul>
                        </div>
                        <p class="copyright">Copyright © 2021. All Rights Reserved 2021</p>
                       
                    </div>
            </div>
        </div>
  </section> -->
  <app-footer></app-footer>